var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronUpSmall = function SvgChevronUpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.736 14.736a.9.9 0 01-1.272 0L12 10.273l-4.464 4.463a.9.9 0 01-1.272-1.272l5.1-5.1a.9.9 0 011.272 0l5.1 5.1a.9.9 0 010 1.272z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43MzY0IDE0LjczNjRDMTcuMzg0OSAxNS4wODc4IDE2LjgxNTEgMTUuMDg3OCAxNi40NjM2IDE0LjczNjRMMTIgMTAuMjcyOEw3LjUzNjM5IDE0LjczNjRDNy4xODQ5MiAxNS4wODc4IDYuNjE1MDcgMTUuMDg3OCA2LjI2MzYgMTQuNzM2NEM1LjkxMjEzIDE0LjM4NDkgNS45MTIxMyAxMy44MTUgNi4yNjM2IDEzLjQ2MzZMMTEuMzYzNiA4LjM2MzU4QzExLjcxNTEgOC4wMTIxMSAxMi4yODUgOC4wMTIxMSAxMi42MzY0IDguMzYzNThMMTcuNzM2NCAxMy40NjM2QzE4LjA4NzkgMTMuODE1MSAxOC4wODc5IDE0LjM4NDkgMTcuNzM2NCAxNC43MzY0WiIgZmlsbD0iIzAyM0Y4MCIvPgo8L3N2Zz4K";
export { SvgChevronUpSmall as ReactComponent };